import { Box, Chip, CircularProgress, Typography } from "@material-ui/core";
import InfoIcon from "@material-ui/icons/Info";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import * as React from "react";
import { useLocalRepairCheck } from "../../../Helper/useLocalRepairCheck";

interface LocalRepairStatusChipProps {
  ownerCode?: string;
  pn?: string;
  onResult?: (isLocalRepair: boolean) => void;
  initialValue?: boolean; // if provided, skips fetch and displays directly
}

const LocalRepairStatusChip = ({ ownerCode, pn, onResult, initialValue }: LocalRepairStatusChipProps) => {
  const skip = initialValue !== undefined;
  const { isLocalRepair: fetchedIsLocalRepair, checking, hasError } = useLocalRepairCheck(ownerCode, pn, skip);

  const isLocalRepair = skip ? (initialValue ?? false) : fetchedIsLocalRepair;
  const checked = skip || (!checking && !hasError) || hasError;

  React.useEffect(() => {
    if (!skip) {
      onResult?.(fetchedIsLocalRepair);
    }
  }, [fetchedIsLocalRepair, skip]);

  if (checking) {
    return (
      <Box display="flex" alignItems="center" style={{ gap: 8, marginBottom: 8 }}>
        <CircularProgress size={16} thickness={5} />
        <Typography variant="caption" color="textSecondary">
          Checking local repair status...
        </Typography>
      </Box>
    );
  }

  if (!checked) return null;

  if (hasError) {
    return (
      <Box style={{ marginBottom: 8 }}>
        <Chip
          icon={<ErrorOutlineIcon style={{ color: "#c62828" }} />}
          label="Could not check local repair status"
          size="small"
          style={{ backgroundColor: "#ffebee", color: "#c62828", fontWeight: 600 }}
        />
      </Box>
    );
  }

  return (
    <Box style={{ marginBottom: 8 }}>
      <Chip
        icon={<InfoIcon style={{ color: "#c62828" }} />}
        label={isLocalRepair ? "Local Repair PN" : "Standard PN"}
        size="small"
        style={{ backgroundColor: "#e3f2fd", color: "#c62828", fontWeight: 600 }}
      />
    </Box>
  );
};

export default LocalRepairStatusChip;
